<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right">
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
      <p class="dp-dept-hint">
        <span class="dp-dept-hint__label">当前学校</span>
        <span class="dp-dept-hint__value">{{ departmentName || '未选择' }}</span>
      </p>

      <div class="tbl-scroll-host">
      <el-table :data="list" v-loading="loading" class="compact-table" style="width: 100%;" height="100%">
        <el-table-column prop="Title" label="名称" width="" show-overflow-tooltip />
        <el-table-column label="校区" width="" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getCampusName(scope.row.CampusId) }}
          </template>
        </el-table-column>
        <el-table-column label="价格类型" width="" align="center">
          <template slot-scope="scope">
            {{ priceTypeName(scope.row.PriceType) }}
          </template>
        </el-table-column>
        <el-table-column label="价格值" width="" align="center">
          <template slot-scope="scope">
            {{ formatRequiredPoints(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="名次/门槛" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ formatClassRankBrief(scope.row) }}</template>
        </el-table-column>
        <el-table-column prop="CategoryTag" label="标签" width="" show-overflow-tooltip />
        <el-table-column label="库存" width="">
          <template slot-scope="scope">
            <div class="stock-cell">
              <div>剩余 {{ scope.row.StockRemain }}</div>
              <div class="stock-total">总量 {{ scope.row.StockTotal }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="每人上限" width="" align="center">
          <template slot-scope="scope">
            {{ formatPerUserLimit(scope.row.PerUserLimit) }}
          </template>
        </el-table-column>
        <el-table-column label="预售" width="" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsPreSale ? 'warning' : 'info'">{{ scope.row.IsPreSale ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="PickupTime" label="领取时间" width="" show-overflow-tooltip />
        <el-table-column prop="ShelfStatus" label="上架" width="" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.ShelfStatus === 1 ? 'success' : 'danger'">
              {{ scope.row.ShelfStatus === 1 ? '上架' : '下架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <div class="op-grid">
              <el-button size="mini" class="op-solid-btn" @click="openEdit(scope.row)">编辑</el-button>
              <el-button size="mini" :class="['op-solid-btn', scope.row.ShelfStatus === 1 ? 'op-danger-btn' : '']" @click="toggleShelf(scope.row)">
                {{ scope.row.ShelfStatus === 1 ? '下架' : '上架' }}
              </el-button>
              <el-dropdown trigger="click" @command="cmd => handlePrizeMoreAction(scope.row, cmd)">
                <el-button size="mini" class="op-solid-btn more-btn">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="release">下发记录</el-dropdown-item>
                  <el-dropdown-item command="exchange">兑换记录</el-dropdown-item>
                  <el-dropdown-item command="delete" divided class="danger-dropdown-item">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <div class="pagination-container">
        <el-pagination
          layout="total, prev, pager, next"
          :current-page="page.currentPage"
          :page-size="page.pageSize"
          :total="page.total"
          @current-change="handleCurrentChange" />
      </div>

    <el-dialog :title="editForm.Id ? '编辑奖品' : '新增奖品'" :visible.sync="editVisible" width="980px" top="6vh" :close-on-click-modal="false">
      <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="奖品名称" prop="Title"><el-input v-model="editForm.Title" /></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属校区" prop="CampusId">
              <el-select v-model="editForm.CampusId" placeholder="请选择校区" style="width: 100%" clearable>
                <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="item.Id" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="价格类型" prop="PriceType">
              <el-radio-group v-model="editForm.PriceType">
                <el-radio :label="0">固定积分</el-radio>
                <el-radio :label="1">百分比</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="requiredPointsLabel" prop="RequiredPoints">
              <div class="price-input-row">
                <el-input-number
                  class="dialog-number"
                  v-model="editForm.RequiredPoints"
                  :min="0"
                  :max="editForm.PriceType === 1 ? 100 : undefined"
                  :precision="2" />
                <span class="price-unit-text">{{ currentPriceUnit }}</span>
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="兑换范围" prop="FreeExchangeScopeJson">
              <el-select v-model="editForm.FreeExchangeScopeJson" placeholder="请选择" style="width: 100%" clearable>
                <el-option v-for="item in exchangeScopeOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型标签"><el-input v-model="editForm.CategoryTag" /></el-form-item>
          </el-col>

          <el-col v-show="isPercentPrice" :span="24">
            <div class="prize-percent-tip">以下仅百分比定价生效；班内名次与德育排行榜（日/周/月）切片一致。</div>
          </el-col>
          <el-col v-show="isPercentPrice" :span="12">
            <el-form-item label="班内名次">
              <el-switch v-model="editForm.ClassRankLimitEnabled" active-text="限前N名" inactive-text="不限制" />
            </el-form-item>
          </el-col>
          <el-col v-show="isPercentPrice" :span="12">
            <el-form-item label="名次周期">
              <el-select
                v-model="editForm.ClassRankPeriodType"
                class="prize-field-full"
                placeholder="请选择"
                :disabled="!editForm.ClassRankLimitEnabled">
                <el-option v-for="o in classRankPeriodOptions" :key="o.value" :label="o.label" :value="o.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-show="isPercentPrice" :span="12">
            <el-form-item label="前 N 名">
              <el-input-number
                v-model="editForm.ClassRankTopN"
                class="prize-field-full"
                :min="1"
                :max="9999"
                :precision="0"
                :disabled="!editForm.ClassRankLimitEnabled"
                controls-position="right" />
            </el-form-item>
          </el-col>
          <el-col v-show="isPercentPrice" :span="12">
            <el-form-item label="余额门槛">
              <el-input-number
                v-model="editForm.MinAvailablePointsToRedeem"
                class="prize-field-full"
                :min="0"
                :precision="2"
                controls-position="right" />
              <div class="limit-tip">兑换时可用积分须 ≥ 该值；不设门槛请留空或 0。</div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="总库存" prop="StockTotal"><el-input-number v-model="editForm.StockTotal" :min="0" /></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="剩余库存" prop="StockRemain"><el-input-number v-model="editForm.StockRemain" :min="0" /></el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="库存预警"><el-input-number v-model="editForm.StockAlertThreshold" :min="0" /></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序"><el-input-number v-model="editForm.SortOrder" :min="0" /></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="每人上限次数">
              <el-input-number v-model="editForm.PerUserLimit" :min="1" :step="1" />
              <div class="limit-tip">留空表示不限制</div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="上下架">
              <el-radio-group v-model="editForm.ShelfStatus">
                <el-radio :label="1">上架</el-radio>
                <el-radio :label="0">下架</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="启用"><el-switch v-model="editForm.Enabled" /></el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="兑换开始">
              <el-date-picker v-model="editForm.ExchangeBeginDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="兑换结束">
              <el-date-picker v-model="editForm.ExchangeEndDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="是否预售"><el-switch v-model="editForm.IsPreSale" /></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预售截止">
              <el-date-picker
                v-model="editForm.PreSaleEndDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                :disabled="!editForm.IsPreSale" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="领取时间">
              <el-date-picker
                v-model="editForm.PickupTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                :disabled="!editForm.IsPreSale" />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="奖品描述"><el-input type="textarea" :rows="2" v-model="editForm.Description" /></el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="封面图片">
              <el-upload
                v-if="!deferredImageDisplay('cover', editForm.CoverImageUrl)"
                class="stable-uploader"
                list-type="picture-card"
                action="#"
                :auto-upload="false"
                :show-file-list="false"
                :limit="1"
                :on-change="handleCoverChange"
                :on-exceed="handleCoverExceed">
                <i class="el-icon-plus"></i>
              </el-upload>
              <div v-else class="single-cover-card">
                <img v-if="deferredImageDisplay('cover', editForm.CoverImageUrl)" v-oss-src="deferredImageDisplay('cover', editForm.CoverImageUrl)" class="single-cover-image" />
                <div class="single-cover-actions">
                  <el-button type="text" size="mini" @click="handleCoverPreview({ url: deferredImageDisplay('cover', editForm.CoverImageUrl) })">预览</el-button>
                  <el-button type="text" size="mini" class="danger-text" @click="clearCover">删除</el-button>
                </div>
              </div>
              <el-dialog :visible.sync="coverPreviewVisible" append-to-body width="520px" class="cover-preview-dialog" :close-on-click-modal="false">
                <img v-if="coverPreviewImageUrl" v-oss-src="coverPreviewImageUrl" class="cover-preview-image" alt="">
              </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitEdit">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="`班级下发记录 - ${currentPrizeTitle || '-'}`" :visible.sync="releaseVisible" width="55%" :close-on-click-modal="false">
      <el-table :data="releaseRows" v-loading="releaseLoading" style="width: 100%">
        <el-table-column prop="ClassDepartmentName" label="班级" width="" />
        <el-table-column prop="SchoolPrizeTitle" label="奖品" width="" />
        <el-table-column prop="AllocatedQuantity" label="下发" width="" />
        <el-table-column prop="RemainQuantity" label="剩余" width="" />
        <el-table-column prop="Status" label="状态" width="">
          <template slot-scope="scope">
            {{ releaseStatusName(scope.row.Status) }}
          </template>
        </el-table-column>
        <el-table-column label="下发时间" min-width="130">
          <template slot-scope="scope">
            <div class="time-cell">
              <div>{{ splitDateTime(scope.row.CreateTime).date }}</div>
              <div>{{ splitDateTime(scope.row.CreateTime).time }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="确认时间" min-width="130">
          <template slot-scope="scope">
            <div class="time-cell">
              <div>{{ splitDateTime(scope.row.ConfirmTime).date }}</div>
              <div>{{ splitDateTime(scope.row.ConfirmTime).time }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="拒绝时间" min-width="130">
          <template slot-scope="scope">
            <div class="time-cell">
              <div>{{ splitDateTime(scope.row.RejectTime).date }}</div>
              <div>{{ splitDateTime(scope.row.RejectTime).time }}</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          layout="total, prev, pager, next"
          :current-page="releasePage.currentPage"
          :page-size="releasePage.pageSize"
          :total="releasePage.total"
          @current-change="handleReleaseCurrentChange" />
      </div>
    </el-dialog>
    <el-dialog :title="`兑换记录 - ${currentPrizeTitle || '-'}`" :visible.sync="exchangeVisible" width="55%" :close-on-click-modal="false">
      <el-table :data="exchangeRows" v-loading="exchangeLoading" style="width: 100%">
        <el-table-column prop="ClassDepartmentName" label="班级" width="" />
        <el-table-column prop="StudentName" label="学生" width="" />
        <el-table-column prop="SpentPoints" label="消耗积分" width="" />
        <el-table-column label="状态" width="" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="exchangeStatusTagType(scope.row.FulfillmentStatus)"
              size="small"
              disable-transitions>
              {{ exchangeStatusName(scope.row.FulfillmentStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="来源" width="" show-overflow-tooltip>
          <template slot-scope="scope">{{ formatExchangeCreateBy(scope.row) }}</template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="兑换时间" width="" />
        <el-table-column label="撤销时间" width="" min-width="150">
          <template slot-scope="scope">{{ scope.row.RevokeTime || '—' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              plain
              :disabled="Number(scope.row.FulfillmentStatus) === 9"
              @click="revokeExchangeRecord(scope.row)">
              撤销
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          layout="total, prev, pager, next"
          :current-page="exchangePage.currentPage"
          :page-size="exchangePage.pageSize"
          :total="exchangePage.total"
          @current-change="handleExchangeCurrentChange" />
      </div>
    </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from '@/components/DepartmentPane.vue'
import Toolbar from '../../components/Toolbar'
import { getButtonList } from '../../promissionRouter'
import { BaseApiUrl } from '../../api/base';
import { getSchoolPrizeListForAdmin, saveSchoolPrizeForAdmin, updateSchoolPrizeShelfForAdmin, deleteSchoolPrizeForAdmin, getSchoolPrizeReleaseRecords, getSchoolPrizeExchangeRecords, revokeSchoolPrizeExchangeRecord } from '../../api/modules/moral-education';
import { getCampusList } from '../../api/modules/misc';
import { normalizeDeptId, treeNodeDeptId, deptIdsEqual } from '../../utils/deptCascaderProps';
export default {
  name: 'SchoolPrizeManage',
  components: { DepartmentPane, Toolbar },
  data() {
    return {
      departmentId: 0,
      departmentName: '',
      keyword: '',
      campusId: null,
      campusOptions: [],
      searchList: [
        { label: '奖品名称', key: 'keyword' },
        {
          label: '选择校区',
          key: 'campusId',
          type: 'select',
          clearable: true,
          options: []
        }
      ],
      buttonList: [],
      exchangeScopeOptions: [
        { label: '可线上兑换', value: '' },
        { label: '仅线下德育处兑换', value: 'offline' },
      ],
      classRankPeriodOptions: [
        { label: '日榜', value: 0 },
        { label: '周榜', value: 1 },
        { label: '月榜', value: 2 },
      ],
      uploadUrl: BaseApiUrl + '/images/Upload/Pic',
      coverFileList: [],
      coverPreviewVisible: false,
      coverPreviewImageUrl: '',
      loading: false,
      list: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      releaseRows: [],
      releaseLoading: false,
      releaseVisible: false,
      exchangeRows: [],
      exchangeLoading: false,
      exchangeVisible: false,
      currentPrizeId: 0,
      currentPrizeTitle: '',
      releasePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      exchangePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      editFormRules: {
        Title: [{ required: true, message: '请输入奖品名称', trigger: 'blur' }],
        CampusId: [{ required: true, message: '请选择所属校区', trigger: 'change' }],
        PriceType: [{ required: true, message: '请选择价格类型', trigger: 'change' }],
        RequiredPoints: [{ required: true, message: '请填写价格值', trigger: 'change' }],
        StockTotal: [{ required: true, message: '请填写总库存', trigger: 'change' }],
        StockRemain: [{ required: true, message: '请填写剩余库存', trigger: 'change' }]
      },
      editVisible: false,
      submitLoading: false,
      editForm: this.buildDefaultForm()
    }
  },
  computed: {
    requiredPointsLabel() {
      return Number(this.editForm.PriceType) === 1 ? '兑换比例' : '兑换积分'
    },
    currentPriceUnit() {
      return Number(this.editForm.PriceType) === 1 ? '%' : '积分'
    },
    isPercentPrice() {
      return Number(this.editForm.PriceType) === 1
    },
  },
  watch: {
    'editForm.IsPreSale'(val) {
      if (!val && this.editForm) this.editForm.PickupTime = null
    },
    'editForm.PriceType'(val) {
      if (Number(val) !== 1 && this.editForm) {
        this.editForm.ClassRankLimitEnabled = false
        this.editForm.ClassRankTopN = null
        this.editForm.MinAvailablePointsToRedeem = null
        this.editForm.ClassRankPeriodType = 0
      }
    },
    'editForm.ClassRankLimitEnabled'(val) {
      if (!val && this.editForm) this.editForm.ClassRankTopN = null
    },
  },
  methods: {
    formatRequiredPoints(row) {
      const value = Number(row && row.RequiredPoints)
      const safeValue = Number.isFinite(value) ? value.toFixed(2) : '0.00'
      return Number(row && row.PriceType) === 1 ? `${safeValue}%` : `${safeValue}积分`
    },
    formatPerUserLimit(value) {
      const num = Number(value)
      if (!Number.isFinite(num) || num <= 0) return '不限制'
      return `${Math.floor(num)}次`
    },
    /** 列表摘要：百分比奖品的班内名次限制与最低可用积分 */
    formatClassRankBrief(row) {
      if (Number(row && row.PriceType) !== 1) return '—'
      const parts = []
      if (row.ClassRankLimitEnabled && Number(row.ClassRankTopN) > 0) {
        const pt = Number(row.ClassRankPeriodType)
        const label = pt === 1 ? '周' : pt === 2 ? '月' : '日'
        parts.push(`前${row.ClassRankTopN}名(${label})`)
      }
      const minAv = Number(row.MinAvailablePointsToRedeem)
      if (Number.isFinite(minAv) && minAv > 0) parts.push(`余额≥${minAv}`)
      return parts.length ? parts.join('；') : '不限'
    },
    callFunction(item) {
      if (typeof item.search === 'object') {
        this.keyword = item.search.keyword || ''
        this.campusId = item.search.campusId || null
      } else {
        this.keyword = item.search || ''
        this.campusId = null
      }
      this[item.Func].apply(this, item)
    },
    handleQuery() {
      this.page.currentPage = 1
      this.loadList()
    },
    handleAdd() {
      this.openCreate()
    },
    buildDefaultForm() {
      return {
        Id: 0,
        Title: '',
        Description: '',
        CoverImageUrl: '',
        RequiredPoints: 0,
        CategoryTag: '',
        StockAlertThreshold: null,
        FreeExchangeScopeJson: '',
        IsPreSale: false,
        PreSaleEndDate: null,
        PickupTime: null,
        StockTotal: 0,
        StockRemain: 0,
        PerUserLimit: null,
        PerWeekLimit: null,
        ExchangeBeginDate: null,
        ExchangeEndDate: null,
        SortOrder: 0,
        Enabled: true,
        ShelfStatus: 1,
        PriceType: 0,
        CampusId: null,
        ClassRankLimitEnabled: false,
        ClassRankPeriodType: 0,
        ClassRankTopN: null,
        MinAvailablePointsToRedeem: null,
      }
    },
    priceTypeName(priceType) {
      return Number(priceType) === 1 ? '百分比' : '固定'
    },
    exchangeStatusName(status) {
      const v = Number(status)
      if (v === 9) return '已撤销'
      return '已兑换'
    },
    exchangeStatusTagType(status) {
      return Number(status) === 9 ? 'info' : 'success'
    },
    /** 兑换来源：新数据「XX家长」「XX教师代兑」；兼容旧库 parent、teacher:id、历史「XX老师」 */
    formatExchangeCreateBy(row) {
      const raw = row && row.CreateBy != null ? String(row.CreateBy).trim() : ''
      const stu = row && row.StudentName ? String(row.StudentName).trim() : ''
      if (!raw) return stu ? `${stu}家长` : '-'
      const lower = raw.toLowerCase()
      if (lower === 'parent') return stu ? `${stu}家长` : '家长端'
      if (/^teacher:\d+$/i.test(raw)) return '教师代兑'
      return raw
    },
    syncCampusSearchOptions() {
      const campusSearch = this.searchList.find(e => e.key === 'campusId')
      if (campusSearch) {
        campusSearch.options = this.campusOptions.map(e => ({
          label: e.Name,
          value: e.Id
        }))
      }
    },
    async loadCampusOptions() {
      if (this.departmentId <= 0) {
        this.campusOptions = []
        this.syncCampusSearchOptions()
        return
      }
      const res = await getCampusList({ page: 1, intPageSize: 999, departmentId: this.departmentId })
      if (res.data && res.data.success) {
        this.campusOptions = (res.data.response && res.data.response.data) || []
      } else {
        this.campusOptions = []
      }
      this.syncCampusSearchOptions()
    },
    getCampusName(campusId) {
      if (!normalizeDeptId(campusId)) return '全部校区'
      const row = this.campusOptions.find(e => deptIdsEqual(e.Id, campusId))
      return row ? row.Name : `校区${campusId}`
    },
    async loadList() {
      if (!normalizeDeptId(this.departmentId)) return this.$message.warning('请先在左侧选择学校')
      this.loading = true
      try {
        const res = await getSchoolPrizeListForAdmin({
          departmentId: this.departmentId,
          campusId: this.campusId,
          page: this.page.currentPage,
          pageSize: this.page.pageSize,
          keyword: this.keyword
        })
        if (res.data.success) {
          const pm = res.data.response || {}
          this.list = pm.data || []
          this.page.total = pm.dataCount || 0
        }
        else this.$message.error(res.data.msg || '查询失败')
      } finally {
        this.loading = false
      }
    },
    async loadReleaseRecords() {
      if (this.departmentId <= 0 || this.currentPrizeId <= 0) return
      this.releaseLoading = true
      try {
        const res = await getSchoolPrizeReleaseRecords({
          departmentId: this.departmentId,
          schoolPrizeId: this.currentPrizeId,
          page: this.releasePage.currentPage,
          pageSize: this.releasePage.pageSize
        })
        if (res.data.success) {
          const pm = res.data.response || {}
          this.releaseRows = pm.data || []
          this.releasePage.total = pm.dataCount || 0
        }
      } finally {
        this.releaseLoading = false
      }
    },
    async loadExchangeRecords() {
      if (this.departmentId <= 0 || this.currentPrizeId <= 0) return
      this.exchangeLoading = true
      try {
        const res = await getSchoolPrizeExchangeRecords({
          departmentId: this.departmentId,
          prizeId: this.currentPrizeId,
          page: this.exchangePage.currentPage,
          pageSize: this.exchangePage.pageSize
        })
        if (res.data.success) {
          const pm = res.data.response || {}
          this.exchangeRows = pm.data || []
          this.exchangePage.total = pm.dataCount || 0
        }
      } finally {
        this.exchangeLoading = false
      }
    },
    releaseStatusName(status) {
      if (status === 0) return '待确认'
      if (status === 1) return '已确认'
      if (status === 2) return '已拒绝'
      return '-'
    },
    splitDateTime(v) {
      if (!v) return { date: '-', time: '' }
      const text = String(v).trim()
      if (!text) return { date: '-', time: '' }
      const parts = text.split(' ')
      if (parts.length >= 2) {
        return { date: parts[0], time: parts.slice(1).join(' ') }
      }
      return { date: text, time: '' }
    },
    handleCoverExceed() {
      this.$message.warning('封面图片最多上传1张，请先删除已上传图片')
    },
    handleCoverChange(file) {
      this.deferredImageChange('cover', file, { foo: 'moralMallPrize', savedUrl: this.editForm.CoverImageUrl })
    },
    clearCover() {
      this.deferredImageRevoke('cover')
      this.editForm.CoverImageUrl = ''
      this.coverFileList = []
    },
    handleCoverPreview(file) {
      this.coverPreviewImageUrl = file.url
      this.coverPreviewVisible = true
    },
    openCreate() {
      this.editForm = this.buildDefaultForm()
      this.editForm.CampusId = this.campusId
      this.coverFileList = []
      this.deferredImageRevoke('cover')
      this.editVisible = true
    },
    openEdit(row) {
      this.editForm = Object.assign(this.buildDefaultForm(), row)
      const scopeRaw = (this.editForm.FreeExchangeScopeJson || '').trim()
      const scope = scopeRaw.toLowerCase()
      if (!scopeRaw || scope === 'all' || scope === 'online' || scope === 'true') {
        this.editForm.FreeExchangeScopeJson = ''
      } else if (scope === 'false') {
        this.editForm.FreeExchangeScopeJson = 'offline'
      }
      this.editForm.ClassRankLimitEnabled = !!this.editForm.ClassRankLimitEnabled
      this.editForm.ClassRankPeriodType = Number(this.editForm.ClassRankPeriodType) || 0
      const topN = this.editForm.ClassRankTopN
      this.editForm.ClassRankTopN = topN != null && topN !== '' && Number(topN) > 0 ? Number(topN) : null
      this.coverFileList = []
      this.deferredImageInit('cover', this.editForm.CoverImageUrl)
      if (this.editForm.CoverImageUrl) {
        const fullUrl = this.$resolveImageSrc(this.editForm.CoverImageUrl)
        this.coverFileList = [{ name: 'cover', url: fullUrl, response: this.editForm.CoverImageUrl }]
      }
      this.editVisible = true
    },
    openReleaseRecords(row) {
      this.currentPrizeId = Number(row && row.Id) || 0
      this.currentPrizeTitle = (row && row.Title) || ''
      this.releasePage.currentPage = 1
      this.releaseVisible = true
      this.releaseRows = []
      this.loadReleaseRecords()
    },
    openExchangeRecords(row) {
      this.currentPrizeId = Number(row && row.Id) || 0
      this.currentPrizeTitle = (row && row.Title) || ''
      this.exchangePage.currentPage = 1
      this.exchangeVisible = true
      this.exchangeRows = []
      this.loadExchangeRecords()
    },
    handlePrizeMoreAction(row, command) {
      if (command === 'release') {
        this.openReleaseRecords(row)
        return
      }
      if (command === 'exchange') {
        this.openExchangeRecords(row)
        return
      }
      if (command === 'delete') {
        this.remove(row)
      }
    },
    async submitEdit() {
      if (!normalizeDeptId(this.departmentId)) return this.$message.warning('请先在左侧选择学校')
      this.$refs.editForm.validate(async valid => {
        if (!valid) return
        this.submitLoading = true
        try {
          const payload = Object.assign({}, this.editForm)
          payload.CoverImageUrl = await this.deferredImageEnsure('cover', { foo: 'moralMallPrize', currentUrl: this.editForm.CoverImageUrl })
          payload.FreeExchangeScopeJson = (payload.FreeExchangeScopeJson || '').trim()
          if (Number(payload.PriceType) !== 1) {
            payload.ClassRankLimitEnabled = false
            payload.ClassRankPeriodType = 0
            payload.ClassRankTopN = null
            payload.MinAvailablePointsToRedeem = null
          } else {
            if (!payload.ClassRankLimitEnabled) {
              payload.ClassRankTopN = null
            }
            const minAv = payload.MinAvailablePointsToRedeem
            if (minAv == null || minAv === '' || Number(minAv) <= 0) {
              payload.MinAvailablePointsToRedeem = null
            }
          }
          const res = await saveSchoolPrizeForAdmin(0, payload, this.departmentId)
          if (res.data.success) {
            this.$message.success('保存成功')
            this.editVisible = false
            this.loadList()
          } else this.$message.error(res.data.msg || '保存失败')
        } finally {
          this.submitLoading = false
        }
      })
    },
    async toggleShelf(row) {
      if (!normalizeDeptId(this.departmentId)) return this.$message.warning('请先在左侧选择学校')
      const targetShelf = row.ShelfStatus === 1 ? 0 : 1
      if (targetShelf === 0) {
        await this.$confirm('确认下架该奖品？', '提示', { type: 'warning' })
      }
      const res = await updateSchoolPrizeShelfForAdmin({ TeacherId: 0, PrizeId: row.Id, ShelfStatus: targetShelf, DepartmentId: this.departmentId })
      if (res.data.success) {
        this.$message.success(res.data.msg || '操作成功')
        this.loadList()
      } else this.$message.error(res.data.msg || '操作失败')
    },
    async remove(row) {
      if (!normalizeDeptId(this.departmentId)) return this.$message.warning('请先在左侧选择学校')
      await this.$confirm('确认删除该奖品？', '提示', { type: 'warning' })
      const res = await deleteSchoolPrizeForAdmin({ id: row.Id, departmentId: this.departmentId })
      if (res.data.success) {
        this.$message.success('删除成功')
        this.loadList()
      } else this.$message.error(res.data.msg || '删除失败')
    },
    handleCurrentChange(page) {
      this.page.currentPage = page
      this.loadList()
    },
    handleReleaseCurrentChange(page) {
      this.releasePage.currentPage = page
      this.loadReleaseRecords()
    },
    handleExchangeCurrentChange(page) {
      this.exchangePage.currentPage = page
      this.loadExchangeRecords()
    },
    async revokeExchangeRecord(row) {
      const exchangeId = Number(row && row.ExchangeId)
      if (!exchangeId) return
      await this.$confirm('确认撤销该兑换记录？撤销后会返还积分并回补库存。', '提示', { type: 'warning' })
      const res = await revokeSchoolPrizeExchangeRecord({ ExchangeId: exchangeId })
      if (res.data && res.data.success) {
        this.$message.success(res.data.msg || '撤销成功')
        await this.loadExchangeRecords()
        await this.loadList()
      } else {
        this.$message.error((res.data && res.data.msg) || '撤销失败')
      }
    },
    treeNodeClick(data) {
      this.departmentId = treeNodeDeptId(data)
      this.departmentName = (data && (data.label || data.Name || data.name)) || ''
      this.campusId = null
      this.campusOptions = []
      this.syncCampusSearchOptions()
      this.page.currentPage = 1
      this.page.total = 0
      this.list = []
      this.currentPrizeId = 0
      this.currentPrizeTitle = ''
      this.releasePage.currentPage = 1
      this.releasePage.total = 0
      this.releaseRows = []
      this.exchangePage.currentPage = 1
      this.exchangePage.total = 0
      this.exchangeRows = []
      this.$nextTick(() => {
        if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
          this.$refs.toolbar.searchObj.campusId = null
        }
        if (this.departmentId > 0) {
          this.loadCampusOptions().then(() => this.loadList())
        }
      })
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    if (!this.buttonList.some(b => b.Func === 'handleQuery')) {
      this.buttonList.unshift({ name: '查询', Func: 'handleQuery', id: 999 })
    }
    if (!this.buttonList.some(b => b.Func === 'handleAdd')) {
      this.buttonList.push({ name: '新增', Func: 'handleAdd', id: 1000 })
    }
  }
}
</script>

<style scoped>
.op-grid {
  width: 100%;
  max-width: 180px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  box-sizing: border-box;
}
.stock-cell { line-height: 1.25; font-size: 12px; }
.stock-total { color: #909399; font-size: 12px; }
.time-cell { line-height: 1.2; }
.danger-text { color: #f56c6c; }
.op-solid-btn {
  width: 56px;
  height: 24px;
  line-height: 22px;
  padding: 0;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #606266;
  background: #fff;
  margin: 0 !important;
  transition: none !important;
}
.op-solid-btn:hover,
.op-solid-btn:focus,
.op-solid-btn:active {
  border-color: #dcdfe6;
  color: #606266;
  background: #fff;
  box-shadow: none !important;
  transform: none !important;
}
.more-btn /deep/ .el-icon--right {
  margin-left: 2px;
}
.more-btn /deep/ .danger-dropdown-item {
  color: #f56c6c;
}
.more-btn /deep/ .danger-dropdown-item:hover,
.more-btn /deep/ .danger-dropdown-item:focus {
  color: #f56c6c;
}
.op-danger-btn {
  border-color: #f56c6c;
  color: #f56c6c;
}
.op-danger-btn:hover,
.op-danger-btn:focus,
.op-danger-btn:active {
  border-color: #f56c6c;
  color: #f56c6c;
  background: #fff;
}
.compact-table /deep/ .el-button--mini { padding: 0; transition: none !important; }
.compact-table /deep/ .cell { line-height: 20px; }
.single-cover-card {
  width: 148px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}
.single-cover-image {
  display: block;
  width: 100%;
  height: 148px;
  object-fit: cover;
}
.single-cover-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 34px;
  border-top: 1px solid #ebeef5;
  background: #fafafa;
}
.cover-preview-dialog /deep/ .el-dialog__body {
  padding: 12px;
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cover-preview-image {
  display: block;
  margin: 0 auto;
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}
.dialog-number {
  width: 100%;
}
.dialog-number /deep/ .el-input-number {
  width: 100%;
}
.price-input-row {
  display: flex;
  align-items: center;
  width: 100%;
  flex-wrap: nowrap;
}
.price-input-row .dialog-number {
  flex: 0 0 220px;
  width: 220px;
}
.price-unit-text {
  margin-left: 8px;
  color: #606266;
  white-space: nowrap;
}
.prize-percent-tip {
  margin: 0 0 4px 0;
  padding: 0 0 2px 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
.prize-field-full {
  width: 100%;
}
.prize-field-full /deep/ .el-input-number {
  width: 100%;
}
.limit-tip {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 1.2;
}
</style>

